import React from "react";
import InfoPanel from "../InfoPanel";

const FieldLabel = ({ htmlFor, children, required = true, infoContent, infoLabel }) => (
  <label className="signup-form__label" htmlFor={htmlFor}>
    <span className="signup-form__label-text">
      {children}
      {required ? <span className="signup-form__required">*</span> : null}
      {infoContent ? (
        <InfoPanel label={infoLabel || children} content={infoContent} />
      ) : null}
    </span>
  </label>
);

export default FieldLabel;
